import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'MyEntries',
            args: {
                ...payload,
                game_id: config.promotion_id,
            },
        });
        return {
            entries: result.myentries,
            drawings: result.drawings,
            grandPrizePoints: result.grandprizepoints,
            currentPoints: result.currentpoints,
            currentDrawId: result.drawid,
        };
    };
};
